import { NoDuplicationValidation } from './duplicate_validation';
import { OneToOneValidation } from './one_to_one_validation';
import { ValidationTypes, ValidationTypeArgs } from './validation_types';
import { OneToManyValidation } from './one_to_many_validation';

export interface IValidationError {
  errorMessage: string;
  type: string;
  sourceTargetKeyMap?: string | number | Record<string, string>;
  sourceObj: Record<string, any>;
  targetObj: Record<string, any>;
  condition: Record<string, any>;
}

export type ValidateMethod = (sourceData: any, sourceKey: string, targetTypeDetails: ValidationTypeArgs) => boolean;
export type ValidationErrorDetail = (
  sourceData: any,
  sourceKey: string,
  targetDataConfig: ValidationTypeArgs
) => IValidationError;

export class Validations {
  static validationMethodStrategy: Record<ValidationTypes, ValidateMethod> = {
    ONE_TO_MANY: OneToManyValidation.validate,
    ONE_TO_ONE: OneToOneValidation.validate,
    NO_DUPLICATES: NoDuplicationValidation.validate
  };

  static validationErrorDetailStrategy: Record<ValidationTypes, ValidationErrorDetail> = {
    ONE_TO_MANY: OneToManyValidation.getErrorDetail,
    ONE_TO_ONE: OneToOneValidation.getErrorDetail,
    NO_DUPLICATES: NoDuplicationValidation.getErrorDetail
  };

  validate(sourceData: any, sourceKey: string, targetTypeDetails: ValidationTypeArgs) {
    const validTypes = Object.keys(Validations.validationMethodStrategy);
    if (!validTypes.includes(targetTypeDetails.type)) {
      console.warn(
        `Unknown 'type' passed to validate the data, acceptable 'type' value should be either of this: ${validTypes}`
      );
      return false;
    }

    return Validations.validationMethodStrategy[targetTypeDetails.type](sourceData, sourceKey, targetTypeDetails);
  }

  getErrorDetails(sourceData: any, sourceKey: string, targetDataConfig: ValidationTypeArgs): IValidationError {
    const validTypes = Object.keys(Validations.validationMethodStrategy);
    if (!validTypes.includes(targetDataConfig.type)) {
      console.warn(
        `Unknown 'type' passed to get the error details, acceptable 'type' value should be either of this: ${validTypes}`
      );
      return {} as IValidationError;
    }
    return Validations.validationErrorDetailStrategy[targetDataConfig.type](sourceData, sourceKey, targetDataConfig);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/pi-validation/src/validation/validations.ts